export default (elem) => elem.getBoundingClientRect().toJSON();
